import React, { useState } from 'react';
import './EnvoyerMailAdmin.css';
import DashboardHeader from '../../components/DashboardHeader';
import AdminNavigationBar from '../../components/AdminNavigationBar';

function EnvoyerSMSAdmin() {
  const [message, setMessage] = useState('');
  const [selectedRecipient, setSelectedRecipient] = useState('Tout le monde');

  const handleSendSMS = (e) => {
    e.preventDefault();
    console.log('Sending SMS to:', selectedRecipient);
    console.log('Message:', message);
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Envoyer un SMS" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="admin-mail-content">
            {/* Stats Cards */}
            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-header">
                  <span className="stat-title">Historique des SMS</span>
                </div>
                <div className="stat-value">450</div>
                <div className="stat-label">SMS envoyés</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <span className="stat-title">Aujourd'hui</span>
                </div>
                <div className="stat-value">25</div>
                <div className="stat-label">SMS reçu</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <span className="stat-title">Non lus</span>
                </div>
                <div className="stat-value">03</div>
                <div className="stat-label">SMS non lus</div>
              </div>

              <div className="stat-card">
                <div className="stat-header">
                  <span className="stat-title">Brouillons</span>
                </div>
                <div className="stat-value">08</div>
                <div className="stat-label">SMS non envoyés</div>
              </div>
            </div>

            {/* SMS Form Card */}
            <div className="mail-form-card">
              <div className="mail-form-header">
                <h2>Nouveau SMS</h2>
                <button className="close-btn">✕</button>
              </div>

              <form onSubmit={handleSendSMS}>
                {/* School Name Section */}
                <div className="form-field">
                  <label className="field-label">Nom de l'école</label>
                  <div className="school-name-box">
                    CS le triangle divin
                  </div>
                </div>

                {/* Recipient Section */}
                <div className="form-field">
                  <label className="field-label">Receveur</label>
                  <select
                    className="recipient-select"
                    value={selectedRecipient}
                    onChange={(e) => setSelectedRecipient(e.target.value)}
                  >
                    <option value="Tout le monde">Tout le monde</option>
                    <option value="Parents">Parents</option>
                    <option value="Enseignants">Enseignants</option>
                    <option value="Élèves">Élèves</option>
                    <option value="Administration">Administration</option>
                  </select>
                </div>

                {/* Message Section */}
                <div className="form-field">
                  <label className="field-label">Message</label>
                  <textarea
                    className="message-textarea"
                    placeholder="Les bulletins seront bientôt disponible sur la plateforme"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows="6"
                  />
                  <div className="message-info">
                    <span className="error-icon">⚠</span>
                    <span className="error-text">Fusco dignissim luctus sem eu dapibus.</span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="form-actions">
                  <div className="action-icons">
                    <button type="button" className="action-icon-btn" title="Ajouter une pièce jointe">
                      📎
                    </button>
                    <button type="button" className="action-icon-btn" title="Insérer une image">
                      🖼
                    </button>
                    <button type="button" className="action-icon-btn" title="Insérer un lien">
                      🔗
                    </button>
                    <button type="button" className="action-icon-btn" title="Emoji">
                      😊
                    </button>
                    <button type="button" className="action-icon-btn" title="Plus d'options">
                      ⋯
                    </button>
                  </div>

                  <button type="submit" className="send-btn">
                    Envoyer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default EnvoyerSMSAdmin;
